var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomPause = function SvgCustomPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.274v8.516c0 1.744 1.925 2.838 3.46 1.966l3.75-2.127 3.75-2.135a2.247 2.247 0 0 0 0-3.924L9.21 7.434 5.46 5.307C3.926 4.435 2 5.521 2 7.274ZM16.891 17.695a.677.677 0 0 1-.678-.668V6.03a.677.677 0 0 1 1.356 0v10.998a.672.672 0 0 1-.678.668ZM20.322 17.695a.677.677 0 0 1-.677-.668V6.03a.677.677 0 0 1 1.355 0v10.998a.672.672 0 0 1-.678.668Z",
    fill: "currentColor"
  })));
};

export default SvgCustomPause;